import React from 'react';
import { Star } from 'lucide-react';

const Testimonials = ({ settings }) => {
    const {
        title = "What Our Customers Say",
        testimonials = [],
        // Section Styling
        bg,
        titleColor,
        // Card Styling
        cardBg,
        nameColor,
        textColor,
        starColor
    } = settings;

    return (
        <div
            className="w-full py-16 px-8 md:px-4 transition-all duration-300"
            style={{
                backgroundColor: bg || 'var(--store-bg)',
                color: textColor || 'var(--store-text)'
            }}
        >
            <div className="max-w-7xl mx-auto">
                {title && (
                    <h2
                        className="text-3xl font-bold text-center mb-12"
                        style={{ color: titleColor || textColor || 'var(--store-text)' }}
                    >
                        {title}
                    </h2>
                )}

                <div className="grid grid-cols-3 md:grid-cols-1 gap-12 md:gap-8">
                    {testimonials.map((t, index) => (
                        <div
                            key={index}
                            className="flex flex-col p-6 rounded-xl transition-all duration-300"
                            style={{ backgroundColor: cardBg || 'var(--store-card-bg)' }}
                        >
                            <div className="flex gap-1 mb-6">
                                {[...Array(5)].map((_, i) => (
                                    <Star
                                        key={i}
                                        size={18}
                                        className="transition-colors duration-300"
                                        style={{
                                            fill: i < t.rating ? (starColor || "#fbbf24") : "transparent",
                                            stroke: i < t.rating ? (starColor || "#fbbf24") : "var(--store-muted)"
                                        }}
                                    />
                                ))}
                            </div>
                            <blockquote
                                className="flex-1 text-xl md:text-lg font-medium leading-relaxed mb-6"
                                style={{ color: textColor || 'var(--store-text)' }}
                            >
                                "{t.text}"
                            </blockquote>
                            <div className="mt-auto flex items-center gap-4">
                                <div
                                    className="w-10 h-10 rounded-full flex items-center justify-center font-bold"
                                    style={{
                                        backgroundColor: textColor || 'var(--store-text)',
                                        color: cardBg || 'var(--store-card-bg)'
                                    }}
                                >
                                    {t.name.charAt(0)}
                                </div>
                                <div className="min-w-0 flex-1">
                                    <p
                                        className="font-bold text-base truncate"
                                        style={{ color: nameColor || textColor || 'var(--store-text)' }}
                                    >
                                        {t.name}
                                    </p>
                                    <p
                                        className="text-sm opacity-70"
                                        style={{ color: textColor || 'var(--store-text)' }}
                                    >
                                        Verified Customer
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
